import { render } from "./MiscDemo.vue?vue&type=template&id=e5ec97d8&scoped=true"
import script from "./MiscDemo.vue?vue&type=script&lang=js"
export * from "./MiscDemo.vue?vue&type=script&lang=js"

import "./MiscDemo.vue?vue&type=style&index=0&id=e5ec97d8&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ec97d8"]])

export default __exports__